import type { AxiosError, AxiosRequestConfig } from '@ori/axios';
import { axios } from '@ori/axios';
import { observable } from 'mobx';

import type { RootStore } from './RootStore';
import { getPublicToken, getQueryParameter } from '~/utils';

export class BaseStore {
  readonly areMocksEnabled = Boolean(getQueryParameter('mocksEnabled'));
  readonly rootStore: RootStore;

  @observable
  networkError?: AxiosError;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  async getUrl<T>(url: string, requestConfig: AxiosRequestConfig = {}) {
    const { globalApiUrl, lang, tenant } = this.rootStore.configurationStore.configuration;
    const extention = requestConfig.responseType === 'blob' ? '.jpg' : '.json';
    const finalUrl = this.areMocksEnabled ? `/mocks${url}${extention}` : `${globalApiUrl}${url}`;
    const axiosOptions = { ...requestConfig };

    if (!this.areMocksEnabled) {
      const token = await getPublicToken();
      if (token) {
        axiosOptions.headers = {
          ...requestConfig.headers,
          'Accept-Language': lang,
          Authorization: token.toString(),
          'x-tenant-context': tenant ?? '',
        };
      }
    }

    try {
      const { data } = await axios.get<T>(finalUrl, axiosOptions);

      return { data };
    } catch (error: unknown) {
      return { error };
    }
  }
}
